import React from 'react';
import PropTypes from 'prop-types';
import AccountCard from './AccountCard';

const AccountCardList = ({ 
  filteredData, expandedAccordion, setExpandedAccordion, selectedAccounts, 
  toggleAccountSelection, canEdit, editAccount, deleteAccount, 
  calculateProgress, updateAccountStatus, updateGoLiveStatus, getStepsForManufacturer, 
  getStatusesForManufacturer, getStatusColor, getApiUrl, setSaveMessage 
}) => (
  filteredData.map((account) => (
    <AccountCard
      key={account.id}
      account={account}
      expandedAccordion={expandedAccordion}
      setExpandedAccordion={setExpandedAccordion}
      selectedAccounts={selectedAccounts}
      toggleAccountSelection={toggleAccountSelection}
      canEdit={canEdit}
      editAccount={editAccount}
      deleteAccount={deleteAccount}
      calculateProgress={calculateProgress}
      updateAccountStatus={updateAccountStatus}
      updateGoLiveStatus={updateGoLiveStatus}
      getStepsForManufacturer={getStepsForManufacturer}
      getStatusesForManufacturer={getStatusesForManufacturer}
      getStatusColor={getStatusColor}
      getApiUrl={getApiUrl}
      setSaveMessage={setSaveMessage}
    />
  ))
);

AccountCardList.propTypes = {
  filteredData: PropTypes.array.isRequired,
  expandedAccordion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setExpandedAccordion: PropTypes.func.isRequired,
  selectedAccounts: PropTypes.array.isRequired,
  toggleAccountSelection: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
  editAccount: PropTypes.func.isRequired,
  deleteAccount: PropTypes.func.isRequired,
  calculateProgress: PropTypes.func.isRequired,
  updateAccountStatus: PropTypes.func.isRequired,
  updateGoLiveStatus: PropTypes.func.isRequired,
  getStepsForManufacturer: PropTypes.func.isRequired,
  getStatusesForManufacturer: PropTypes.func.isRequired,
  getStatusColor: PropTypes.func.isRequired,
  getApiUrl: PropTypes.func.isRequired,
  setSaveMessage: PropTypes.func.isRequired
};

export default AccountCardList;